

import axios from 'axios';
import { showToast } from '../library/utility';
import store from "../store";
import * as Constants from "../../constants/Constants";
import T from "i18n-react";
export function userAuthenticated(decoded) {

	return function (dispatch) {

		if (sessionStorage.getItem("platform") === "skid") {
			dispatch({ type: "AUTH_SUCCESS_CIAM", payload: decoded });
		} else {
			dispatch({ type: "AUTH_SUCCESS_AZURE", payload: decoded });
		}
	}
}

export function updateUserAgreement(formdata) {


	return (dispatch) => {
		axios.defaults.headers.common['Content-Type'] = 'application/json; charset=UTF-8';
		dispatch({ type: "RESET_SUCCESS_CLOSE" });
		dispatch({ type: "RESET_ERROR_CLOSE" });
		dispatch({ type: "API_LOADING" });
		axios.post(process.env.UAT_SCC + "/itrams/usermanagement/signup", formdata).then(
			response => {
				dispatch({ type: "STOP_API_LOADING" });
				if (response.data) {
					if (response.data.responseCode == "500") {
						dispatch({ type: "USER_REG_FAIL" });
						this.setState({ useralreadyExists: true });
					} else if (response.data.responseCode == "EAE") {

						const newEmail = document.getElementById("emailID");
						newEmail.classList.add("border-danger");
						document.getElementById("email_Label").innerHTML = T.translate("error_Codes.UMIDAE");
						dispatch({ type: "USER_REG_FAIL" });
					} else if (response.data.responseCode == "INE") {

						const newEmail = document.getElementById("emailID");
						newEmail.classList.add("border-danger");
						document.getElementById("email_Label").innerHTML = "Please enter Valid Email";
						dispatch({ type: "USER_REG_FAIL" });
					}else if (response.data.responseCode == "INV") {
						dispatch({ type: "USER_REG_FAIL" });
					}else if (response.data.responseCode == "IBE") {
						dispatch({ type: "USER_REG_FAIL_IBE" });
					} else {
						dispatch({ type: "USER_REG_SUCCESS" });
					}
				} else {
					dispatch({ type: "USER_REG_FAIL" });
				}
				dispatch({ type: "STOP_API_LOADING" });
			}

		).catch(error => {
			//console.log("FAIL");
			dispatch({ type: "STOP_API_LOADING" });
			dispatch({ type: "USER_REG_FAIL" });
		})
	}
	// dispatch({type: "AUTH_SUCCESS_CIAM",payload:email});
}


export function updateUserRevisedTC(formdata) {

	return (dispatch) => {
		axios.defaults.headers.common['Content-Type'] = 'application/json; charset=UTF-8';

		axios.post(process.env.UAT_SCC + "/itrams/usermanagement/updateRevisedTC", formdata).then(
			response => {
				
				if (response.data == true){
					//dispatch({ type: "USER_UPD_SUCCESS",payload: {displayRegPopUp: false, emailID: email ,showNotice:false,isuserAgreed: true, show: false}});
					
					this.setState({displayRegPopUp:false, emailID: email ,showNotice:false,isuserAgreed: true, show: false}, () =>console.log("Test"));

					alert(this.state.isuserAgreed);
				}
				else{
					dispatch({ type: "USER_UPD_FAIL" });
				}
			}
		).catch(error => {
			dispatch({ type: "USER_UPD_FAIL" });
		})
	}
	// dispatch({type: "AUTH_SUCCESS_CIAM",payload:email});
}
export function signOutUser() {
	var cookies = document.cookie.split(";");

	for (var i = 0; i < cookies.length; i++) {
		var cookie = cookies[i];
		var eqPos = cookie.indexOf("=");
		var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
		document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
	}
	if (sessionStorage.getItem("platform") === "azure") {
		return function (dispatch) {
			// dispatch({ type: "LOG_OUT" });
			sessionStorage.clear();
			localStorage.clear();


			window.location = Constants.CONFIG.logout_uri;
		}
	} else {
		return function (dispatch) {
			var params = {
				id_token_hint: sessionStorage.getItem("id_token"),
				post_logout_redirect_uri: Constants.CONFIG.post_logout_redirect_uri,
				state: Constants.CONFIG.state
			}
			var finalParams = Object.keys(params).map(key => key + '=' + params[key]).join('&');
			var url = localStorage.getItem("end_session_endpoint") + "?" + finalParams;
			window.location = url;
			sessionStorage.clear();
			localStorage.clear();
			dispatch({ type: "LOG_OUT" });
		}
	}
}

export function reastAndHandleClose() {
	return function (dispatch) {
		dispatch({ type: "RESET_CLOSE" });
	}
}








